import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import * as actions from "../../../store/slices/AssessmentSlice";
import { useParams } from "react-router-dom";

const useDietPlanData = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const patientInfo = JSON.parse(localStorage.getItem("PatientInfo") || "{}");
  
  const {
    dietPlanData: { data, isLoading, errors },
  } = useSelector((state: RootState) => state.assessment);

  const fetchDietPlanData = (assessmentId: string) => {
    const payload = {
      patient_id: params?.patientId || patientInfo?.patient_id,
      assessment_id: assessmentId,
    };
    dispatch(actions.getDietPlanDataRequest(payload));
  };

  return {
    data,
    isLoading,
    errors,
    fetchDietPlanData,
  };
};

export default useDietPlanData;
